import { ComponentMeta, ComponentStory } from "@storybook/react";
import { Edit3Icon } from "lucide-react";
import React from "react";
import { Button } from "../Button";
import Flex from "../Flex";
import { Typography } from "../Typography";
import { RadioGroup, Select } from "../form";
import Modal from "./Modal";
import { imageUrl } from "./__story__";
import { ModalCloseButton } from "./components";
import { noop } from "../../utils";

type Story = ComponentStory<typeof Modal>;

const commonArgs: React.ComponentProps<typeof Modal> = {
    defaultOpen: true,
    disablePortal: true
};

export default {
    title: "common/Modal",
    component: Modal,
    args: commonArgs,
    parameters: {
        chromatic: { pauseAnimationAtEnd: true }
    }
} as ComponentMeta<typeof Modal>;

const Template: Story = args => <Modal {...args} />;

const RADIO_OPTIONS = ["pickable_type", "picking_zone", "usage", "label_details"] as const;

export const WithRadio = Template.bind({});
WithRadio.args = {
    style: {
        padding: 24
    },
    children: (
        <Flex alignItems="flex-start" spacing={3}>
            <Edit3Icon />
            <Flex column spacing={3}>
                <Typography variant="label-medium-medium">You are trying to edit {"<X>"} Storage Locations.</Typography>
                <Select
                    inPortal
                    onChange={noop}
                    options={[
                        { label: "one", value: "1" },
                        { label: "two", value: "2" },
                        { label: "three", value: "3" },
                        { label: "four", value: "4" },
                        { label: "five", value: "5" },
                        { label: "six", value: "6" },
                        { label: "seven", value: "7" },
                        { label: "eight", value: "8" },
                        { label: "nine", value: "9" },
                        { label: "ten", value: "10" }
                    ]}
                    trackName=""
                />

                <RadioGroup<(typeof RADIO_OPTIONS)[number]>
                    label="Select from the following editable categories:"
                    trackName="radio_group"
                    defaultValue="pickable_type"
                    options={RADIO_OPTIONS}
                    getOptionValue={v => v}
                    getOptionLabel={v =>
                        v
                            .split("_")
                            .map(w => `${w.charAt(0).toUpperCase()}${w.slice(1)}`)
                            .join(" ")
                    }
                    getHelperText={value => {
                        switch (value) {
                            case "pickable_type":
                                return "Change between Pickable, Non Pickable, and Bulk Pickable.";
                            case "picking_zone":
                                return "Set zones (e.g. Zone A, Zone B) to split the picking workforce into different picking zones/aisles.";
                            case "usage":
                                return "Change between Storage (default), Inbound, and Returns.";
                            case "label_details":
                                return "Customize the arrows to show relative relation between locations.";
                            default:
                                return null;
                        }
                    }}
                />
                <Flex justifyContent="flex-end" spacing={1}>
                    <ModalCloseButton title="Cancel" variant="secondary" />
                    <Button title="Confirm" trackName="confirm" />
                </Flex>
            </Flex>
        </Flex>
    )
};

export const Picture = Template.bind({});
Picture.args = {
    children: (
        <Flex column spacing={2}>
            <img style={{ display: "block", padding: 0 }} src={imageUrl} alt="example" />
            <Flex justifyContent="flex-end">
                <ModalCloseButton title="Close" />
            </Flex>
        </Flex>
    )
};
